/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRadioButtonSet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 17a3 3 0 1 1-.001 6.001A3 3 0 0 1 4 17zm0 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 4 19zm19 0v2H9v-2zM4 9a3 3 0 1 1-.001 6.001A3 3 0 0 1 4 9zm0 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 4 11zm19 0v2H9v-2zM4 1c1.654 0 3 1.346 3 3S5.654 7 4 7 1 5.654 1 4s1.346-3 3-3zm19 2v2H9V3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRadioButtonSet as RadioButtonSet };
